<template>
  <div>
    <app-board>
      <moduleForm :dataContainer="dataContainer" :edit-mode="false" :formHeader="true"
                  :formTitle="module.info.caption"></moduleForm>
    </app-board>

   <!-- <app-board class="mt-3">
      <uploadRatesDocument></uploadRatesDocument>
    </app-board>-->
  </div>
</template>

<script>
import dataContainer from 'devegram-vue-data-collecter-eui/src/mixins/dataContainer';
import module from './../index.js'

export default {
  mixins: [dataContainer],
  components: {
    moduleForm: () => import('./../form/View'),
    /*uploadRatesDocument: () => import('./../upload-rates-document/View')*/
  },
  data() {
    return {
      dataContainer: this,
      module: module
    }
  }
}
</script>
